<template>
  <div>
    <PageTitleVue :sub-title="page.subtitle">
      {{ page.title }}
    </PageTitleVue>

    <GroupsTabs>
      <template #group>
        <GroupsView />
      </template>

      <template #students>
        <FightersView />
      </template>
    </GroupsTabs>
  </div>
</template>

<script setup>
import GroupsTabs from './components/_partials/GroupsTabs.vue'
import PageTitleVue from '@/components/Titles/PageTitle.vue'
import FightersView from './FightersView.vue'
import GroupsView from './GroupsView.vue'
import { dataFighters } from './store'
import { onMounted, computed } from 'vue'
import { showToast as toast } from '@/helpers/UseToasts'
import collabService from './services/collab.service'
import { storeApp } from '@/store'
import { dataGroups } from './store/groups'

const page = computed(() => dataFighters.getters.getPageConf)
const appStore = storeApp.state

async function getCustomers () {
  await collabService.getCustomers()
    .then(res => {
      dataFighters.dispatch('setFightersCollect', res.data)
    }).catch(err => {
      toast(
        'Erro',
        'Algo deu errado ao buscar coleção alunos',
        'error'
      )
    })
}

onMounted(() => {
  appStore.loading = true

  dataFighters.dispatch('difineConfigsForPage', {
    title: 'Turmas',
    subtitle: 'Gerencie suas turmas'
  })

  Promise.all([
    getCustomers(),
    dataGroups.dispatch('getGroups')
  ])

  appStore.loading = false
})
</script>
